export async function postServer(connectionRepository, url, body) {
    return await connectionRepository.post(url, body)
}